module.exports = __webpack_public_path__ + "media/images/products/category/owner-1be18095bef8f2ad2b2c682f769d9bff.jpg";